import { useState, useEffect, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { ENV } from 'lib/config';
import {
  APP,
  ADDRESS,
  COPYRIGHT,
  SOCIAL_LINKS,
  FOOTER_LINKS,
} from 'lib/strings';
import { ConfluenceAPI } from 'lib/confluence';
import {
  OMenuItem,
  UnifiedMenu,
  Shell,
  Navigation,
  Scope,
  Search as OmniSearch,
} from 'lib/omnibar';
import { Footer } from 'lib/raul';

import Router from './Router';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [items, setItems] = useState<OMenuItem[]>();
  const [hideSearch, setHideSearch] = useState(false);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    setHideSearch(['/', '/search'].includes(location.pathname));
  }, [location]);

  // Load Sidebar Navigation Items
  useEffect(() => {
    (async () => {
      const api = new ConfluenceAPI();
      const navItems = await api.getNavigationItems();

      setItems(navItems);
      setIsLoading(false);
    })();
  }, []);

  // Subscribe to Navigation Events
  const onNavigate = useCallback(
    (url: string) => {
      history.push(url);
    },
    [history]
  );

  // Enable Navbar Search
  const onSearch = (searchTerm: string) => {
    history.push(`/search?searchTerm=${searchTerm}`);
  };

  return (
    <Shell environment={ENV} isLoading={isLoading}>
      <>
        <Scope base={APP.TAGLINE} product={APP.TITLE} />
        <OmniSearch
          hide={hideSearch}
          onSearch={onSearch}
          placeholder={APP.SEARCH}
        />
        <Navigation items={items} onNavigate={onNavigate} />
        <UnifiedMenu hide />
        <main className="r-flex r-flex-col" slot="page">
          <Router
            className="r-min-h-content"
            items={items}
            onSearch={onSearch}
          />
          <Footer
            address={ADDRESS}
            className="r-mt-auto r-hide-print"
            copyright={COPYRIGHT}
            footerLinks={FOOTER_LINKS}
            socialLinks={SOCIAL_LINKS}
          />
        </main>
      </>
    </Shell>
  );
}

export default App;
